import React from "react";
import PropTypes from "prop-types";

export function RadioQuestion({ label, name, options, disabled, questionColClass, size }) {
  const hasWideAnswer = questionColClass != null;
  const questionCol = hasWideAnswer ? "col-12 col-md-6" : "col-12 col-md-8";
  const answerCol = hasWideAnswer ? "col-12 col-md-6" : "col-12 col-md-4";
  const btnClass = size === "sm" ? "btn btn-outline-primary btn-sm px-3 py-1" : "btn btn-outline-primary px-4 py-2";

  return (
    <div className="form-group mb-3">
      <div className="row align-items-center">
        <div className={questionCol}>
          <p className="mb-1 mb-md-0">{label}</p>
        </div>
        <div className={answerCol}>
          <div className={`d-flex justify-content-end ${size === "sm" ? "gap-1" : "gap-3"}`}>
            {options.map(({ id, value, label: optionLabel, defaultChecked }) => (
              <React.Fragment key={id}>
                <input
                  className="btn-check"
                  type="radio"
                  id={id}
                  name={name}
                  autoComplete="off"
                  value={value}
                  defaultChecked={defaultChecked}
                  disabled={disabled}
                />
                <label htmlFor={id} className={btnClass}>
                  {optionLabel}
                </label>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

RadioQuestion.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
      label: PropTypes.string.isRequired,
      defaultChecked: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    })
  ).isRequired,
  disabled: PropTypes.bool,
  questionColClass: PropTypes.string,
  size: PropTypes.string,
};
